export class QuestionBase<T>{
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  type: any;
  options: any;
  text: any;

  constructor(options: {
    value?: T,
    key?: string,
    label?: string,
    required?: boolean,
    minmumlength?: number,
    order?: number,
    controlType?: string
  } = {}) {
    this.value = options.value as any;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType as any;
  }
}